import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {fullName} from 'shared/tools';

class ExternalUser extends DomainObject {
  id;
  firstName;
  lastName;
  isPendingInvitation;
  email;
  assignedRoles = [];

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      firstName: observable,
      lastName: observable,
      isPendingInvitation: observable,
      email: observable,
      assignedRoles: observable,
      name: computed,
      status: computed
    });

    this.merge(other);
  }

  get name() {
    return fullName(this);
  }

  get status() {
    return this.isPendingInvitation ? 'Invite Pending' : 'Active';
  }
}

export default ExternalUser;
